import { useEffect, useState } from "react";
import { useDialogs } from "./DialogsContext";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const { openAudit, openBook } = useDialogs();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-40 transition-colors duration-300 ${
        scrolled
          ? "bg-[#050505]/85 backdrop-blur-md border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto flex items-center justify-between px-6 lg:px-10 h-16">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-2 group"
        >
          <span className="w-2.5 h-2.5 bg-[#ccff00] block" />
          <span className="font-display text-lg tracking-tight uppercase">
                Pipeline<span className="text-[#ccff00]">Forge</span>
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8 text-sm text-white/70 font-medium">
          <a href="#how" className="hover:text-white transition-colors">How it works</a>
          <a href="#calculator" className="hover:text-white transition-colors">Calculator</a>
          <a href="#proof" className="hover:text-white transition-colors">Proof</a>
          <a href="#pricing" className="hover:text-white transition-colors">Pricing</a>
          <a href="#faq" className="hover:text-white transition-colors">FAQ</a>
        </nav>
        <div className="flex items-center gap-2">
          <button
            data-testid="nav-cta-book"
            onClick={openBook}
            className="hidden sm:inline-flex h-9 px-4 items-center text-xs uppercase tracking-widest font-semibold text-white border border-white/15 hover:border-white/40 transition-colors"
          >
            Book a call
          </button>
          <button
            data-testid="nav-cta-audit"
            onClick={openAudit}
            className="h-9 px-4 inline-flex items-center text-xs uppercase tracking-widest font-bold bg-[#ccff00] text-black hover:bg-[#b3e600] transition-colors"
          >
            Free audit
          </button>
        </div>
      </div>
    </header>
  );
}
